const BASE_ATTRIBUTE = 'data-component';
export const NAME_ATTRIBUTE = "".concat(BASE_ATTRIBUTE, "-name");
export const __DEPRECATED_RENDER_EVENT = '__renderedTangramLayoutComponent'; // Deprecated
export const MOUNT_OR_UPDATE_EVENT = '__mountOrUpdateTangramComponent';
export const UNMOUNT_EVENT = '__unmountTangramComponent';